import { useId, type SVGProps } from "react";

export const Afisha = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${id}-a)`}>
        <mask
          id={`${id}-b`}
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path
            d="M0 19.2C0 12.4794 0 9.11905 1.30792 6.55211C2.4584 4.29417 4.29417 2.4584 6.55211 1.30792C9.11905 0 12.4794 0 19.2 0H20.8C27.5206 0 30.8809 0 33.4479 1.30792C35.7058 2.4584 37.5416 4.29417 38.6921 6.55211C40 9.11905 40 12.4794 40 19.2V20.8C40 27.5206 40 30.8809 38.6921 33.4479C37.5416 35.7058 35.7058 37.5416 33.4479 38.6921C30.8809 40 27.5206 40 20.8 40H19.2C12.4794 40 9.11905 40 6.55211 38.6921C4.29417 37.5416 2.4584 35.7058 1.30792 33.4479C0 30.8809 0 27.5206 0 20.8V19.2Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#${id}-b)`}>
          <rect width="40" height="40" fill="#FFF500" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6597 0H29.6594L27.3535 20.6403L39.9999 15.8948V20.7647L26.7912 25.6739L25.1907 40H20.628L22.0455 27.4377L17.044 29.2966L13.6384 40H8.89995L11.6781 31.2909L-0.00012207 35.6313V30.9046L13.4061 25.874L21.6597 0ZM24.4689 5.96102L22.6118 22.4196L18.7739 23.8597L24.4689 5.96102Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id={`${id}-a`}>
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Deli = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();

  return (
    <svg fill="none" viewBox="0 0 40 40" width="40" height="40" {...props}>
      <g clipPath={`url(#${id}-a)`}>
        <mask
          id={`${id}-b`}
          width="40"
          height="40"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
        >
          <path
            fill="#fff"
            d="M0 19.2C0 12.48 0 9.12 1.308 6.552a12 12 0 0 1 5.244-5.244C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.648 1.308a12 12 0 0 1 5.244 5.244C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.308 12.648a12 12 0 0 1-5.244 5.244C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.648-1.308a12 12 0 0 1-5.244-5.244C0 30.88 0 27.52 0 20.8v-1.6Z"
          />
        </mask>
        <g mask={`url(#${id}-b)`}>
          <path fill="red" d="M0 0h40v40H0z" />
          <path
            fill="#FFF500"
            d="M31.242 28.084a13.669 13.669 0 0 1-9.076 3.445c-7.27 0-12.716-5.63-12.716-12.065 0-6.052 4.825-10.993 10.807-10.993 5.646 0 9.72 4.377 9.72 9.117 0 4.442-3.505 8.046-7.811 8.046-3.94 0-6.72-2.984-6.72-6.17 0-2.86 2.212-5.098 4.813-5.098 2.303 0 3.723 1.678 3.723 3.222 0 1.34-.942 2.149-1.816 2.149-.309 0-.427-.065-.551-.143.281-.362.421-.833.35-1.324a1.728 1.728 0 0 0-1.96-1.462c-.808.12-1.322.67-1.576 1.079a2.969 2.969 0 0 0-.44 1.577c0 2.274 2.119 3.744 4.177 3.744 3.007.002 5.268-2.624 5.268-5.62 0-3.667-3.178-6.693-7.175-6.693-4.642 0-8.265 3.93-8.265 8.569 0 5.256 4.481 9.639 10.174 9.639 6.293 0 11.262-5.24 11.262-11.517C33.43 10.838 27.717 5 20.26 5 12.324 5 6 11.542 6 19.464 6 27.922 13.1 35 22.168 35c4.337 0 8.316-1.629 11.353-4.308l-2.28-2.608Zm-9.806-8.658c-.002-.002 0-.004 0 0Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id={`${id}-a`}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Delivery = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();

  return (
    <svg fill="none" viewBox="0 0 40 40" width="40" height="40" {...props}>
      <g clipPath={`url(#${id}-a)`}>
        <mask
          id={`${id}-b`}
          width="40"
          height="40"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
        >
          <path
            fill="#fff"
            d="M0 19.2C0 12.48 0 9.12 1.3 6.55a12 12 0 0 1 5.25-5.24C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.65 1.3a12 12 0 0 1 5.24 5.25C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.3 12.65a12 12 0 0 1-5.25 5.24C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.65-1.3a12 12 0 0 1-5.24-5.25C0 30.88 0 27.52 0 20.8v-1.6Z"
          />
        </mask>
        <g mask={`url(#${id}-b)`}>
          <path fill="#F5F4F2" d="M0 0h40v40H0z" />
          <path
            fill="#FF7751"
            d="m-2.7 8.46 18.02-6.5 18.04 6.5v23.08l-18.04 6.5-18.03-6.5V8.46Z"
          />
          <path
            fill="#E13100"
            d="m-2.7 8.46 18.02 6.5v23.07L-2.7 31.54V8.46Z"
          />
          <path
            fill="#FC4714"
            d="m33.36 8.46-18.04 6.5v23.07l18.04-6.49V8.46Z"
          />
          <path
            fill="#fff"
            d="M31.37 27.4c-3.87 3.76-10.08 5.9-14.06 5.13V30.5c3.9.8 10.16-1.15 14.06-5.12v2.03Zm-7.99-5.92-1.28.47v5.44l-3.2 1.16v-5.44l-1.27.47 2.87-7.86 2.88 5.76Zm7.67-2.8-1.28.47v5.45l-3.2 1.16v-5.44l-1.27.46 2.88-7.85 2.87 5.76Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id={`${id}-a`}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Drive = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();
  const clipPathIdThird = useId();
  const clipPathIdFourth = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <mask
          id={clipPathIdSecond}
          width={40}
          height={40}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
        >
          <path
            fill="#fff"
            d="M0 19.2C0 12.48 0 9.12 1.308 6.552a12 12 0 0 1 5.244-5.244C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.648 1.308a12 12 0 0 1 5.244 5.244C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.308 12.648a12 12 0 0 1-5.244 5.244C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.648-1.308a12 12 0 0 1-5.244-5.244C0 30.88 0 27.52 0 20.8v-1.6Z"
          />
        </mask>
        <g mask={`url(#${clipPathIdSecond})`}>
          <path fill="#F5F4F2" d="M0 0h40v40H0z" />
          <path
            fill={`url(#${clipPathIdThird})`}
            fillRule="evenodd"
            d="M6.823 5.392A21.2 21.2 0 0 0 .302 6.4 8.652 8.652 0 0 0 0 8.665v22.666a8.666 8.666 0 0 0 4.862 7.787c2.22-1.316 4.544-3.083 6.913-5.451 11.093-11.09 11.13-28.275-4.952-28.275Z"
            clipRule="evenodd"
          />
          <path
            fill={`url(#${clipPathIdFourth})`}
            fillRule="evenodd"
            d="M33.663 14.766c0-8.014-3.42-12.445-8.78-14.766H8.665A8.67 8.67 0 0 0 .301 6.399a21.134 21.134 0 0 1 6.521-1.007c16.08 0 16.044 17.185 4.952 28.277-2.368 2.368-4.694 4.133-6.913 5.451 1.149.563 2.44.88 3.805.88h9.084c9.54-5.759 15.913-15.34 15.913-25.234Z"
            clipRule="evenodd"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={clipPathIdThird}
          x1="9.787"
          x2="9.787"
          y1="5.392"
          y2="39.118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F4042" />
          <stop offset={1} stopColor="#1F2021" />
        </linearGradient>
        <linearGradient
          id={clipPathIdFourth}
          x1="16.982"
          x2="16.982"
          y1={0}
          y2={40}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#739EFA" />
          <stop offset={1} stopColor="#1538C2" />
        </linearGradient>
        <clipPath id={clipPathIdFirst}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Eats = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <mask
          id={clipPathIdSecond}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path
            d="M0 19.2C0 12.48 0 9.12 1.308 6.552a12 12 0 0 1 5.244-5.244C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.648 1.308a12 12 0 0 1 5.244 5.244C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.308 12.648a12 12 0 0 1-5.244 5.244C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.648-1.308a12 12 0 0 1-5.244-5.244C0 30.88 0 27.52 0 20.8v-1.6Z"
            fill="#fff"
          />
        </mask>
        <g mask={`url(#${clipPathIdSecond})`}>
          <path fill="#FCE000" d="M0 0h40v40H0z" />
          <path
            d="M31.242 28.084a13.669 13.669 0 0 1-9.076 3.445c-7.27 0-12.716-5.63-12.716-12.065 0-6.052 4.825-10.993 10.807-10.993 5.646 0 9.72 4.377 9.72 9.117 0 4.442-3.505 8.046-7.811 8.046-3.94 0-6.72-2.984-6.72-6.17 0-2.86 2.212-5.098 4.813-5.098 2.303 0 3.723 1.678 3.723 3.222 0 1.34-.942 2.149-1.816 2.149-.309 0-.427-.065-.551-.143.281-.362.421-.833.35-1.324a1.728 1.728 0 0 0-1.96-1.462c-.808.12-1.322.67-1.576 1.079a2.969 2.969 0 0 0-.44 1.577c0 2.274 2.119 3.744 4.177 3.744 3.007.002 5.268-2.624 5.268-5.62 0-3.667-3.178-6.693-7.175-6.693-4.642 0-8.265 3.93-8.265 8.569 0 5.256 4.481 9.639 10.174 9.639 6.293 0 11.262-5.24 11.262-11.517C33.43 10.838 27.717 5 20.26 5 12.324 5 6 11.542 6 19.464 6 27.922 13.1 35 22.168 35c4.337 0 8.316-1.629 11.353-4.308l-2.28-2.608Zm-9.806-8.658c-.002-.002 0-.004 0 0Z"
            fill="#212121"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathIdFirst}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GarageBlack = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path
        fill="#000"
        d="M-.00012207 19.2c0-6.7206 0-10.08095 1.30792207-12.64789C2.45828 4.29417 4.29405 2.4584 6.55199 1.30792 9.11893 0 12.4792 0 19.1999 0h1.6c6.7206 0 10.0809 0 12.6479 1.30792 2.2579 1.15048 4.0937 2.98625 5.2442 5.24419C39.9999 9.11905 39.9999 12.4794 39.9999 19.2v1.6c0 6.7206 0 10.0809-1.3079 12.6479-1.1505 2.2579-2.9863 4.0937-5.2442 5.2442C30.8808 40 27.5205 40 20.7999 40h-1.6c-6.7207 0-10.08097 0-12.64791-1.3079-2.25794-1.1505-4.09371-2.9863-5.24419-5.2442C-.00012207 30.8809-.00012207 27.5206-.00012207 20.8v-1.6Z"
      />
      <path
        fill="#FED331"
        d="M6.99976 13.13V6.99988H33V13.13H6.99976ZM6.99976 33.0001V26.87H20.0346v6.1301H6.99976ZM20.0346 20.2466H6.99976v6.1302H20.0346v-6.1302ZM6.99976 19.7534v-6.1302H33v6.1302H6.99976Z"
      />
    </svg>
  );
};

export const GarageYellow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path
        fill="#FED331"
        d="M-.00012207 19.2c0-6.7206 0-10.08095 1.30792207-12.64789C2.45828 4.29417 4.29405 2.4584 6.55199 1.30792 9.11893 0 12.4792 0 19.1999 0h1.6c6.7206 0 10.0809 0 12.6479 1.30792 2.2579 1.15048 4.0937 2.98625 5.2442 5.24419C39.9999 9.11905 39.9999 12.4794 39.9999 19.2v1.6c0 6.7206 0 10.0809-1.3079 12.6479-1.1505 2.2579-2.9863 4.0937-5.2442 5.2442C30.8808 40 27.5205 40 20.7999 40h-1.6c-6.7207 0-10.08097 0-12.64791-1.3079-2.25794-1.1505-4.09371-2.9863-5.24419-5.2442C-.00012207 30.8809-.00012207 27.5206-.00012207 20.8v-1.6Z"
      />
      <path
        fill="#000"
        d="M6.99976 13.13V6.99988H33V13.13H6.99976ZM6.99976 33.0001V26.87H20.0346v6.1301H6.99976ZM20.0346 20.2466H6.99976v6.1302H20.0346v-6.1302ZM6.99976 19.7534v-6.1302H33v6.1302H6.99976Z"
      />
    </svg>
  );
};
export const Lavka = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <mask
          id={clipPathIdSecond}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path
            d="M0 19.2C0 12.48 0 9.12 1.308 6.552a12 12 0 0 1 5.244-5.244C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.648 1.308a12 12 0 0 1 5.244 5.244C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.308 12.648a12 12 0 0 1-5.244 5.244C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.648-1.308a12 12 0 0 1-5.244-5.244C0 30.88 0 27.52 0 20.8v-1.6Z"
            fill="#fff"
          />
        </mask>
        <g mask={`url(#${clipPathIdSecond})`}>
          <path d="M40 0H0v40h40V0Z" fill="#00ADFF" />
          <path
            d="M20.698 19.95C22.54 10.247 23.85 8.564 27.87 8.876c3.143.244 6.796 4.78 3.498 14.58-3.177 9.448-10.187 11.127-15.28 8.108-3.693-2.19-6.605-6.921-7.708-9.53C6.644 17.93 5.733 13.445 8.017 11c1.87-2.005 4.019-2.972 8.07 1.633 4.052 4.605 4.611 7.317 4.611 7.317Z"
            fill="#fff"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathIdFirst}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Maps = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();
  const clipPathIdThird = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdThird})`}>
        <mask
          id={clipPathIdFirst}
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path
            d="M0 19.2C0 12.4794 0 9.11905 1.30792 6.55211C2.4584 4.29417 4.29417 2.4584 6.55211 1.30792C9.11905 0 12.4794 0 19.2 0H20.8C27.5206 0 30.8809 0 33.4479 1.30792C35.7058 2.4584 37.5416 4.29417 38.6921 6.55211C40 9.11905 40 12.4794 40 19.2V20.8C40 27.5206 40 30.8809 38.6921 33.4479C37.5416 35.7058 35.7058 37.5416 33.4479 38.6921C30.8809 40 27.5206 40 20.8 40H19.2C12.4794 40 9.11905 40 6.55211 38.6921C4.29417 37.5416 2.4584 35.7058 1.30792 33.4479C0 30.8809 0 27.5206 0 20.8V19.2Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#${clipPathIdFirst})`}>
          <rect width="40" height="40" fill="#F5F7F9" />
          <circle cx="19.5" cy="17.5" r="5.5" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.80005 17.6289C7.80005 11.0013 13.1724 5.62891 19.8 5.62891C26.4276 5.62891 31.8 11.0013 31.8 17.6289C31.8 20.9415 30.4579 23.9409 28.287 26.1123C27.7204 26.6793 26.9533 27.3124 26.1235 27.9971C23.7737 29.9364 20.9218 32.2901 20.7 34.7289C20.6551 35.2237 20.2968 35.6289 19.8 35.6289C19.3032 35.6289 18.945 35.2237 18.9 34.7289C18.6783 32.2901 15.8264 29.9364 13.4766 27.9971C12.6468 27.3124 11.8797 26.6793 11.313 26.1123C9.14225 23.9409 7.80005 20.9415 7.80005 17.6289ZM23.9997 17.629C23.9997 19.9486 22.1193 21.829 19.7997 21.829C17.4801 21.829 15.5997 19.9486 15.5997 17.629C15.5997 15.3094 17.4801 13.429 19.7997 13.429C22.1193 13.429 23.9997 15.3094 23.9997 17.629Z"
            fill={`url(#${clipPathIdSecond})`}
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={clipPathIdSecond}
          x1="19.8"
          y1="5.62891"
          x2="19.8"
          y2="35.6289"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6122" />
          <stop offset="1" stopColor="#F22411" />
        </linearGradient>
        <clipPath id={clipPathIdThird}>
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Market = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <mask
          id={clipPathIdSecond}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path
            d="M0 19.2C0 12.48 0 9.12 1.308 6.552a12 12 0 0 1 5.244-5.244C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.648 1.308a12 12 0 0 1 5.244 5.244C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.308 12.648a12 12 0 0 1-5.244 5.244C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.648-1.308a12 12 0 0 1-5.244-5.244C0 30.88 0 27.52 0 20.8v-1.6Z"
            fill="#fff"
          />
        </mask>
        <g mask={`url(#${clipPathIdSecond})`}>
          <path fill="#FF5226" d="M0 0h40v40H0z" />
          <path
            d="M17.371 2.706-6.529 40H3.694l14.48-22.547-.314-.143-3.574 14.36 7.566 1.333 7.777-9.771-.421-.211-2.627 11.101 17.267-3.29-3.38-5.563-6.707 1.534.7.807 2.767-11.594-6.444-4.31-8.442 10.614.422.211 3.467-13.906-8.86-5.919Z"
            fill="#FD0"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathIdFirst}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Scooters = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();
  const clipPathIdThird = useId();
  const clipPathIdFourth = useId();
  const clipPathIdFifth = useId();
  const clipPathIdSixth = useId();
  const clipPathIdSeventh = useId();
  const clipPathIdEighth = useId();
  const clipPathIdNinth = useId();
  const clipPathIdTenth = useId();
  const clipPathIdEleventh = useId();
  const clipPathIdTwelfth = useId();
  const clipPathIdThirteenth = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <mask
          id={clipPathIdSecond}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path
            d="M0 19.2C0 12.48 0 9.12 1.308 6.552a12 12 0 0 1 5.244-5.244C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.648 1.308a12 12 0 0 1 5.244 5.244C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.308 12.648a12 12 0 0 1-5.244 5.244C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.648-1.308a12 12 0 0 1-5.244-5.244C0 30.88 0 27.52 0 20.8v-1.6Z"
            fill="#fff"
          />
        </mask>
        <g mask={`url(#${clipPathIdSecond})`}>
          <path fill="#F5F4F2" d="M0 0h40v40H0z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.779 26.75c0-4.418-1.919-8-4.286-8h-2.38c-2.21 0-4 3.582-4 8s1.79 8 4 8h2.38c2.367 0 4.286-3.582 4.286-8Z"
            fill={`url(#${clipPathIdThird})`}
          />
          <ellipse
            cx="2.142"
            cy="4.285"
            rx="2.142"
            ry="4.285"
            transform="matrix(-1 0 0 1 3.588 22.465)"
            fill="#fff"
          />
          <ellipse
            cx="1.65"
            cy="3.675"
            rx="1.65"
            ry="3.675"
            transform="matrix(-1 0 0 1 2.602 23.075)"
            fill="#EDECE8"
          />
          <path
            stroke="#000"
            strokeOpacity=".15"
            strokeWidth=".833"
            strokeLinecap="round"
            d="M-3.342 35h32.5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.742 18.75h5.834v12.083H6.492a3.75 3.75 0 0 1-3.75-3.75h10.834l4.166-8.333Z"
            fill={`url(#${clipPathIdFourth})`}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.742 18.75h5.834v12.083H6.492a3.75 3.75 0 0 1-3.75-3.75h10.834l4.166-8.333Z"
            fill={`url(#${clipPathIdFifth})`}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.742 18.75h5.834v12.083H6.492a3.75 3.75 0 0 1-3.75-3.75h10.834l4.166-8.333Z"
            fill={`url(#${clipPathIdSixth})`}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.15-9.363a2.708 2.708 0 0 1 2.954 2.438l2.302 23.975-5.392.517-2.302-23.975a2.708 2.708 0 0 1 2.438-2.955Z"
            fill={`url(#${clipPathIdSeventh})`}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.242 26.75c0-4.418-1.919-8-4.286-8h-2.38c-2.21 0-4 3.582-4 8s1.79 8 4 8h2.38c2.367 0 4.286-3.582 4.286-8Z"
            fill={`url(#${clipPathIdEighth})`}
          />
          <mask
            id={clipPathIdTenth}
            maskUnits="userSpaceOnUse"
            x="17"
            y="18"
            width="12"
            height="17"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.242 26.75c0-4.418-1.919-8-4.286-8h-2.38c-2.21 0-4 3.582-4 8s1.79 8 4 8h2.38c2.367 0 4.286-3.582 4.286-8Z"
              fill={`url(#${clipPathIdNinth})`}
            />
          </mask>
          <g mask={`url(#${clipPathIdTenth})`}>
            <path
              d="M21.522 23.238c1.052-2.953 3.297-3.512 5.048-3.018 0 0-1.588-2.592-4.181-2.427-2.879.183-4.49 3.175-4.824 4.495.167 0 2.162.95 3.957.95Z"
              fill={`url(#${clipPathIdEleventh})`}
            />
          </g>
          <ellipse
            cx="2.142"
            cy="4.285"
            rx="2.142"
            ry="4.285"
            transform="matrix(-1 0 0 1 23.051 22.465)"
            fill="#fff"
          />
          <ellipse
            cx="1.65"
            cy="3.675"
            rx="1.65"
            ry="3.675"
            transform="matrix(-1 0 0 1 22.065 23.075)"
            fill="#EDECE8"
          />
          <path
            d="M1.646 27.114h11.045c.288 0 .432 0 .56-.043a.835.835 0 0 0 .305-.18c.099-.092.168-.219.306-.472l4.242-7.777c.138-.252.207-.379.305-.47a.832.832 0 0 1 .305-.182c.128-.042.272-.042.56-.042h6.97"
            stroke={`url(#${clipPathIdTwelfth})`}
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <path
            d="M18.908 17.948h7.336"
            stroke={`url(#${clipPathIdThirteenth})`}
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <path
            d="M19.987 3.452a.667.667 0 0 1 .664-.728h.715a.75.75 0 0 1 .747.68l.362 3.933a.667.667 0 0 1-.664.728h-.715a.75.75 0 0 1-.747-.682l-.362-3.931Z"
            fill="#fff"
          />
          <path
            opacity=".9"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.994 3.273h.195c.701 0 1.29.524 1.373 1.22l.418 3.55a.667.667 0 0 0 .495-.706l-.362-3.932a.75.75 0 0 0-.747-.681h-.715c-.331 0-.601.24-.657.549Z"
            fill="#fff"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={clipPathIdFourth}
          x1="-1.389"
          y1="30.833"
          x2="20.098"
          y2="30.833"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".083" stopColor="#5C5A57" />
          <stop offset="1" stopColor="#5C5A57" />
        </linearGradient>
        <linearGradient
          id={clipPathIdFifth}
          x1="1.837"
          y1="28.348"
          x2="1.837"
          y2="32.131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#21201F" />
          <stop offset="1" stopColor="#5C5A57" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={clipPathIdSixth}
          x1="25.671"
          y1="30.124"
          x2="2.742"
          y2="30.006"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".337" stopColor="#21201F" />
          <stop offset="1" stopColor="#5C5A57" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={clipPathIdSeventh}
          x1="16.485"
          y1="10.224"
          x2="25.249"
          y2="9.196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E69800" />
          <stop offset=".439" stopColor="#FCB900" />
          <stop offset="1" stopColor="#FFF09F" />
        </linearGradient>
        <linearGradient
          id={clipPathIdEleventh}
          x1="26.57"
          y1="19.861"
          x2="19.1"
          y2="19.983"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".118" stopColor="#21201F" />
          <stop offset="1" stopColor="#32302F" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={clipPathIdTwelfth}
          x1="12.211"
          y1="31.795"
          x2="12.211"
          y2="9.372"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E69800" />
          <stop offset=".441" stopColor="#FCB900" />
          <stop offset="1" stopColor="#FFF09F" />
        </linearGradient>
        <linearGradient
          id={clipPathIdThirteenth}
          x1="24.262"
          y1="15.233"
          x2="19.964"
          y2="17.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDB62" />
          <stop offset="1" stopColor="#FFF09F" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id={clipPathIdThird}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(4.61728 16.66633 -9.74002 2.6984 .817 26.75)"
        >
          <stop offset=".373" stopColor="#21201F" />
          <stop offset=".961" stopColor="#706E6B" />
        </radialGradient>
        <radialGradient
          id={clipPathIdEighth}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(74.515 -7.444 26.706) scale(17.2941 10.1069)"
        >
          <stop offset=".373" stopColor="#32302F" />
          <stop offset=".961" stopColor="#706E6B" />
        </radialGradient>
        <radialGradient
          id={clipPathIdNinth}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(74.515 -7.444 26.706) scale(17.2941 10.1069)"
        >
          <stop offset=".373" stopColor="#272625" />
          <stop offset=".792" stopColor="#42413E" />
        </radialGradient>
        <clipPath id={clipPathIdFirst}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Taxi = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();
  const clipPathIdThird = useId();
  const clipPathIdFourth = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <mask
          id={clipPathIdSecond}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path
            d="M0 19.2C0 12.48 0 9.12 1.308 6.552a12 12 0 0 1 5.244-5.244C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.648 1.308a12 12 0 0 1 5.244 5.244C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.308 12.648a12 12 0 0 1-5.244 5.244C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.648-1.308a12 12 0 0 1-5.244-5.244C0 30.88 0 27.52 0 20.8v-1.6Z"
            fill="#fff"
          />
        </mask>
        <g mask={`url(#${clipPathIdSecond})`}>
          <path fill="#2B2A28" d="M20 20h20v20H20z" />
          <path fill={`url(#${clipPathIdThird})`} d="M0 20h20v20H0z" />
          <path fill={`url(#${clipPathIdFourth})`} d="M0 0h40v20H0z" />
        </g>
      </g>
      <defs>
        <linearGradient
          id={clipPathIdThird}
          x1="10"
          y1="20"
          x2="10"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F1EF" />
          <stop offset="1" stopColor="#FCF8E8" />
        </linearGradient>
        <linearGradient
          id={clipPathIdFourth}
          x1="20"
          y1="0"
          x2="20"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD927" />
          <stop offset="1" stopColor="#FBB806" />
        </linearGradient>
        <clipPath id={clipPathIdFirst}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Uber = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <mask
          id={clipPathIdSecond}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path
            d="M0 19.2C0 12.48 0 9.12 1.308 6.552a12 12 0 0 1 5.244-5.244C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.648 1.308a12 12 0 0 1 5.244 5.244C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.308 12.648a12 12 0 0 1-5.244 5.244C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.648-1.308a12 12 0 0 1-5.244-5.244C0 30.88 0 27.52 0 20.8v-1.6Z"
            fill="#fff"
          />
        </mask>
        <g mask={`url(#${clipPathIdSecond})`}>
          <path fill="#060606" d="M0 0h40v40H0z" />
          <path
            d="M8.754 23.91c1.451 0 2.573-1.12 2.573-2.776v-6.447h1.571v10.447h-1.556v-.97c-.703.73-1.675 1.149-2.768 1.149-2.244 0-3.965-1.627-3.965-4.088v-6.536H6.18v6.445c0 1.686 1.108 2.776 2.574 2.776ZM14.065 14.688h1.511v3.805a3.773 3.773 0 0 1 2.709-1.134c2.244 0 4.01 1.776 4.01 3.984 0 2.194-1.766 3.97-4.01 3.97a3.814 3.814 0 0 1-2.725-1.134v.954h-1.497l.002-10.445Zm4.115 9.297c1.436 0 2.618-1.18 2.618-2.642a2.624 2.624 0 0 0-2.618-2.641 2.627 2.627 0 0 0-2.633 2.641 2.628 2.628 0 0 0 2.633 2.642ZM26.814 17.374c2.199 0 3.815 1.686 3.815 3.954v.493H24.42c.21 1.238 1.242 2.164 2.528 2.164.884 0 1.631-.359 2.2-1.12l1.092.806c-.763 1.015-1.9 1.627-3.292 1.627-2.289 0-4.054-1.701-4.054-3.97 0-2.148 1.69-3.954 3.92-3.954Zm-2.364 3.253h4.653c-.254-1.164-1.197-1.94-2.32-1.94-1.121 0-2.064.776-2.333 1.94ZM34.683 18.866c-.987 0-1.705.761-1.705 1.94v4.328h-1.512v-7.61h1.497v.94c.374-.612.988-1 1.826-1h.523v1.403h-.629Z"
            fill="#fff"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathIdFirst}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const YandexPro = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <mask
          id={clipPathIdSecond}
          width="40"
          height="40"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
        >
          <path
            fill="#fff"
            d="M0 19.2C0 12.48 0 9.12 1.3 6.55a12 12 0 0 1 5.25-5.24C9.12 0 12.48 0 19.2 0h1.6c6.72 0 10.08 0 12.65 1.3a12 12 0 0 1 5.24 5.25C40 9.12 40 12.48 40 19.2v1.6c0 6.72 0 10.08-1.3 12.65a12 12 0 0 1-5.25 5.24C30.88 40 27.52 40 20.8 40h-1.6c-6.72 0-10.08 0-12.65-1.3a12 12 0 0 1-5.24-5.25C0 30.88 0 27.52 0 20.8z"
          />
        </mask>
        <g mask={`url(#${clipPathIdSecond})`}>
          <path fill="#000" d="M40 0H0v40h40z" />
          <path
            fill="#ffd913"
            fillRule="evenodd"
            d="M35.27 20a15.27 15.27 0 1 1-30.54 0 15.27 15.27 0 0 1 30.54 0m-5.1-7.68s-3.31 3.07-3.31 7.68 3.32 7.68 3.32 7.68l-2.5 2.5s-3.13-3.32-7.68-3.32-7.68 3.32-7.68 3.32l-2.5-2.5s3.32-3.07 3.32-7.68-3.32-7.68-3.32-7.68l2.5-2.5s3.15 3.32 7.68 3.32 7.68-3.32 7.68-3.32z"
            clipRule="evenodd"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathIdFirst}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
